import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMultianalytics from "vue-multianalytics";
import BootstrapVue from 'bootstrap-vue'
import "./assets/css/theme.scss"
import "./assets/css/custom.scss"
import VueTypedJs from 'vue-typed-js'
import utilsMixin from "@/mixins/utils";
import trackingMixin from "@/mixins/tracking";
import VueGtm from 'vue-gtm';
import VueMeta from "vue-meta";
import VueCalendly from 'vue-calendly';

import VueLogger from 'vuejs-logger';
const isProduction = process.env.NODE_ENV === 'production';
 
const options = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};
 
Vue.use(VueLogger, options);

Vue.use(VueCalendly);
Vue.use(VueTypedJs)
Vue.use(BootstrapVue)
Vue.use(VueMeta);
Vue.mixin(utilsMixin);
Vue.mixin(trackingMixin);

Vue.config.productionTip = false
let gaConfig = {
  appName: "Ludimos Web App", // Mandatory
  appVersion: "1.0", // Mandatory
  trackingId: process.env.VUE_APP_GA_TRACKING_CODE, // Mandatory
  debug: true, // Whether or not display console logs debugs (optional)
  ecommerce: true
};

let fbConfig = {
  token: process.env.VUE_APP_FACEBOOK_PIXEL,
  debug: true
};

Vue.use(VueMultianalytics, {
  modules: {
    ga: gaConfig,
    facebook: fbConfig
  },
  routing: {
    vueRouter: router, //  Pass the router instance to automatically sync with router (optional)
    preferredProperty: "name" // By default 'path' and related with vueRouter (optional)
  }
});

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  enabled: true,
  debug: true,
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
